import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";
import { SubjectHistoryFeed } from "../../../../types";
import { useDeleteSubjectActionModal } from "./useDeleteSubjectActionModal";

type Props = {
  item: SubjectHistoryFeed;
  onClose: () => void;
}

export default function DeleteSubjectActionModal(props: Props) {
  const hook = useDeleteSubjectActionModal(props);

  return (
    <ConfirmDeleteDialog
      title="Supprimer l'action"
      onConfirm={hook.handleConfirm}
      onClose={props.onClose}
    >
      Supprimer cette action de l&apos;historique du sous-sujet&nbsp;?
    </ConfirmDeleteDialog>
  );
}
